import {
  setLopToken,
  removeLopToken,
  setUserPhone,
  getStoredUserName,
  getUserPhone,
} from '@/utils/auth';
import * as mutationTypes from 'constants/mutation-types';
import { getPhoneCode, phoneLogin } from '@/api';

export default {

  startPhoneCodeCountDown({ commit }, count) {
    return new Promise((resolve) => {
      commit(mutationTypes.SET_PHONE_CODE_COUNT_DOWN, count);
      resolve();
    });
  },

  getPhoneCode({ commit }, mobile) {
    return getPhoneCode(mobile)
      .then(() => {
        // 验证码发送倒计时，避免用户频繁触发该请求
        commit(mutationTypes.SET_PHONE_CODE_COUNT_DOWN, 60);
      });
  },

  phoneLogin({ commit }, loginInfo) {
    const { phone, code } = loginInfo;
    // lop服务器登录
    return phoneLogin(phone, code)
      .then((res) => {
        // lop服务器登录结果处理
        const token = res.data ? res.data.token : res.token;
        const userInfo = res.data ? res.data.userInfo : null;
        // 尝试从本地获取该手机号之前存过的昵称
        const storedName = getStoredUserName(phone);

        commit(mutationTypes.SET_LOP_TOKEN, token);
        setLopToken(token);
        setUserPhone(token, phone);

        // 如果接口返回了用户信息，则优先更新到 store
        if (userInfo) {
          const { userId, userName, userAvatar, userSig } = userInfo;
          commit(mutationTypes.UPDATE_USER_INFO, {
            userId: userId || phone,
            userName: userName || storedName || '',
            userAvatar: userAvatar || '',
          });
          if (userSig) {
            commit(mutationTypes.SET_USER_SIG, userSig);
          }
        } else {
          // 兜底处理：设置 userId 为手机号，userName 优先尝试从本地恢复，否则设为空以触发设置弹窗
          commit(mutationTypes.UPDATE_USER_INFO, {
            userId: phone,
            userName: storedName || '',
            userAvatar: '',
          });
        }
      });
  },

  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit(mutationTypes.SET_TOKEN, '');
      commit(mutationTypes.SET_LOP_TOKEN, '');
      removeLopToken();
      resolve();
    });
  },

  // 这里的 getUserInfo 目前在 API 层没有对应的 LOP 实现，目前从本地存储中恢复以支持页面刷新
  getUserInfo({ commit, state }) {
    return new Promise((resolve) => {
      const { lopToken } = state;
      if (lopToken) {
        const phone = getUserPhone(lopToken);
        if (phone) {
          const storedName = getStoredUserName(phone);
          const userInfo = {
            userId: phone,
            userName: storedName || '',
            userAvatar: '',
          };
          commit(mutationTypes.UPDATE_USER_INFO, userInfo);
          resolve(userInfo);
          return;
        }
      }

      if (state.userInfo && state.userInfo.userId) {
        resolve(state.userInfo);
      } else {
        resolve({});
      }
    });
  },

  logout({ dispatch }) {
    return new Promise((resolve) => {
      dispatch('resetToken').then(() => {
        location.reload();
      });
      resolve();
    });
  },
};
